import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformWldlReviewRecords from '@/types/table/platformWldlReviewRecords';
import { PlatformWldlUploadedWorksData } from '@/api/generated/platformWldlUploadedWorksController';
import { PlatformWldlUserData } from '@/api/generated/platformWldlUserController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformWldlReviewRecordsData extends PlatformWldlReviewRecords {
  platformWldlUploadedWorks?: PlatformWldlUploadedWorksData;
  platformWldlUser?: PlatformWldlUserData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformWldlReviewRecordsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformWldlReviewRecordsData>>(API_CONTEXT + '/app/platformWldlReviewRecords/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformWldlReviewRecordsData>(API_CONTEXT + '/app/platformWldlReviewRecords/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformWldlReviewRecords/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformWldlReviewRecords/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformWldlReviewRecords/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlReviewRecords/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlReviewRecords/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlReviewRecords/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlReviewRecords/deleteBatch', params, httpOptions);
  }
}
